// WindowBadge — the small window chip in a card header. Reflects the global
// selected window (from OptionsFlowContext) so every card badge follows the one
// selector; `override` forces a fixed label (unusual_activity is window-
// independent and shows "live"). Renders nothing when there's no window (e.g. a
// card rendered outside the provider in isolation).

import { useContext } from 'react';
import { Box } from '@mui/material';

import { tokens } from '../../../../styles/tokens';
import { OptionsFlowContext } from '../../../../providers/options-flow/options-flow-provider';
import { windowLabel } from '../../../../providers/options-flow/options-flow.helpers';

export const WindowBadge = ({ override }: { override?: string }) => {
  const { activeWindow } = useContext(OptionsFlowContext);
  const label = override ?? (activeWindow ? windowLabel(activeWindow) : undefined);
  if (!label) return null;
  return (
    <Box
      sx={{
        fontSize: 9,
        fontWeight: 600,
        letterSpacing: '0.4px',
        color: tokens.text.muted,
        border: `1px solid ${tokens.border.default}`,
        borderRadius: '4px',
        padding: '1px 6px',
      }}
    >
      {label}
    </Box>
  );
};
